module.exports = __webpack_public_path__ + "static/media/c1bannerModul3_small.88f4f310.jpg";